import {PinIcon, PinSlashIcon} from '@primer/octicons-react'
import {ActionList} from '@primer/react'

import {LABELS} from '../../constants/labels'
import type {SavedView} from './types'

export interface PinControls {
  togglePin: (view: SavedView) => void
}

export function PinViewMenuItem({view, pinControls}: {view: SavedView; pinControls?: PinControls}) {
  if (!pinControls) return null

  return (
    <ActionList.Item onSelect={() => pinControls.togglePin(view)}>
      <ActionList.LeadingVisual>{view.pinned ? <PinSlashIcon /> : <PinIcon />}</ActionList.LeadingVisual>
      <span>{view.pinned ? LABELS.views.unpin : LABELS.views.pin}</span>
    </ActionList.Item>
  )
}
